var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedlineLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Skin Health Logo LG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 35,
    viewBox: "0 0 100 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M0 34.955h35.171V0H0z",
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 3",
    d: "M2.285 0 0 11.35 5.191 0H2.285",
    transform: "translate(14.208 20.012)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M26.628 9.875 16.267 7.741 17.4 0l-4.036 7.741L0 9.875h26.628",
    transform: "translate(5.54 3.59)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5",
    d: "M1.911.005h1.737l-.634 2.678L4.937.005 6.671 0 4.762 3.959H3.719L5.373.641 2.827 3.959h-.992L2.544.615.951 3.959H0L1.911.005",
    transform: "translate(3.613 14.809)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 6",
    d: "M1.905 0h2.988l-.364.755h-1.9l-.4.823H4.02l-.364.756H1.87l-.407.843H3.4l-.369.766H0L1.905 0",
    transform: "translate(9.157 14.825)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 7",
    d: "M1.694 3.953H0L1.913 0h1.681a1.968 1.968 0 0 1 1.358.33c.23.232.408.7-.044 1.635A3.239 3.239 0 0 1 2.936 3.8a4.078 4.078 0 0 1-1.242.153zM2.632.731 1.45 3.192h.523A2.1 2.1 0 0 0 3.935 1.98c.249-.492.311-.826.192-1.019-.137-.223-.5-.225-.821-.227H2.632z",
    transform: "translate(12.854 14.814)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 8",
    d: "M1.913 0h1.119L1.494 3.176h1.592l-.378.777H0L1.913 0",
    transform: "translate(17.708 14.814)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9",
    d: "M1.913 0h1.135L1.136 3.953H0L1.913 0",
    transform: "translate(21.092 14.814)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 10",
    d: "M1.912 0h1.522l-.082 2.946L4.767 0h.963L3.819 3.953H2.33l.114-3.07-1.477 3.07H0L1.912 0",
    transform: "translate(23.011 14.814)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 11",
    d: "M1.908 0H4.9l-.371.755h-1.9l-.4.823h1.794l-.366.756H1.871l-.407.843H3.4l-.371.766H0L1.908 0",
    transform: "translate(27.686 14.825)",
    style: {
      fill: "#fffffe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 12",
    d: "M5.76 0a12.613 12.613 0 0 1 4.513.726 3.856 3.856 0 0 1-.859 2.52A12.07 12.07 0 0 0 6.3 2.818c-1.849 0-2.73.555-2.73 1.644 0 1.174 1.784 1.452 3.589 2.092 1.892.683 3.783 1.751 3.783 4.547 0 3.1-1.913 4.782-5.8 4.782A11.853 11.853 0 0 1 0 14.837a4.739 4.739 0 0 1 .817-2.6 14.223 14.223 0 0 0 4.084.662c1.7 0 2.472-.555 2.472-1.644 0-.982-.967-1.409-2.214-1.836C3.009 8.71.086 8.07.086 4.7.086 1.9 1.87 0 5.76 0",
    transform: "translate(42.468 .165)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 13",
    d: "M6.147 4.868A6.054 6.054 0 0 1 7.758 4.7a7.984 7.984 0 0 1 1.7.171L6.662 9.927l3.289 5.913a8 8 0 0 1-1.848.192 7.2 7.2 0 0 1-1.763-.192l-2.515-4.547H3.31v4.547a6.371 6.371 0 0 1-1.633.171A6.977 6.977 0 0 1 0 15.84V.128A9.482 9.482 0 0 1 1.676 0 9.865 9.865 0 0 1 3.31.128v8.8h.559l2.278-4.06",
    transform: "translate(54.606 .134)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 14",
    d: "M1.655 16.225A6.107 6.107 0 0 1 0 16.054V5.081a6.106 6.106 0 0 1 1.655-.171 6.749 6.749 0 0 1 1.655.171v10.973a6.861 6.861 0 0 1-1.655.171zm0-13.215A6.134 6.134 0 0 1 0 2.839V.171A6.106 6.106 0 0 1 1.655 0 6.749 6.749 0 0 1 3.31.171v2.668a6.883 6.883 0 0 1-1.655.171z",
    transform: "translate(65.754 .039)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 15",
    d: "M9.478 11.336a6.258 6.258 0 0 1-1.655.171 6.065 6.065 0 0 1-1.655-.171V3.864c0-.79-.387-1.281-1.375-1.281a2.222 2.222 0 0 0-1.483.6v8.155a6.46 6.46 0 0 1-1.655.171A6.06 6.06 0 0 1 0 11.336V.384A6.06 6.06 0 0 1 1.655.213 6.46 6.46 0 0 1 3.31.384v.641A4.168 4.168 0 0 1 6.19 0a2.969 2.969 0 0 1 3.288 3.2v8.134",
    transform: "translate(71.033 4.639)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 16",
    d: "M8.274.192A6.806 6.806 0 0 1 9.994 0a6.8 6.8 0 0 1 1.719.192v14.987a6.514 6.514 0 0 1-1.7.192 6.11 6.11 0 0 1-1.741-.192v-6.3H3.439v6.3a7.023 7.023 0 0 1-1.72.192A6.025 6.025 0 0 1 0 15.179V.192A6.52 6.52 0 0 1 1.7 0a6.9 6.9 0 0 1 1.739.192v5.914h4.835V.192",
    transform: "translate(42.579 19.584)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 17",
    d: "M5.179 11.721C1.646 11.721 0 9.876 0 5.914 0 2.045 1.739 0 5.029 0A4.507 4.507 0 0 1 8.3 1.1a4.558 4.558 0 0 1 1.157 3.383 10.681 10.681 0 0 1-.237 2.349H3.4a2.611 2.611 0 0 0 .757 1.756 2.323 2.323 0 0 0 1.564.443 5.261 5.261 0 0 0 2.278-.512 3.378 3.378 0 0 1 1.01 2.241 6.989 6.989 0 0 1-3.83.961zm-.086-9.33a1.369 1.369 0 0 0-1.126.531 3.577 3.577 0 0 0-.594 1.86h3.074a6.355 6.355 0 0 0 .043-.662c0-.789-.242-1.729-1.397-1.729z",
    transform: "translate(55.613 23.279)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 18",
    d: "M3.331 11.721C1.152 11.721 0 10.436 0 8.006c0-2.345 1.366-3.437 4.3-3.437.667 0 1.35.045 1.87.085v-.341c0-1.092-.576-1.623-1.762-1.623a8.491 8.491 0 0 0-2.622.491 2.529 2.529 0 0 1-.709-1A2.668 2.668 0 0 1 .86.876 9.856 9.856 0 0 1 4.943 0a5.1 5.1 0 0 1 3.476.966A3.772 3.772 0 0 1 9.478 3.95v7.387a4.563 4.563 0 0 1-1.376.17 4.856 4.856 0 0 1-1.376-.17L6.34 10.29a3.084 3.084 0 0 1-3.009 1.431zm1.462-5.145c-1.012 0-1.483.461-1.483 1.451 0 1.034.384 1.495 1.246 1.495a1.379 1.379 0 0 0 1.249-.7 3.058 3.058 0 0 0 .363-1.542v-.64c-.42-.04-.896-.064-1.375-.064z",
    transform: "translate(66.075 23.234)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 19",
    d: "M3.31 15.84a6.449 6.449 0 0 1-1.655.171A6.053 6.053 0 0 1 0 15.84V.171A6.053 6.053 0 0 1 1.655 0 6.449 6.449 0 0 1 3.31.171V15.84",
    transform: "translate(77.223 18.944)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 20",
    d: "M5.008 9.572c0 1.473.6 1.815 1.741 1.815a5.042 5.042 0 0 0 .86-.086 3.023 3.023 0 0 1 .258 1.3 3.35 3.35 0 0 1-.15 1.067 7.391 7.391 0 0 1-1.934.235c-2.9 0-4.084-1.281-4.084-4.249V4.81H.15A3.963 3.963 0 0 1 0 3.658a3.771 3.771 0 0 1 .15-1.2H1.7V.563A6.345 6.345 0 0 1 5.008.029v2.434h2.321a3.874 3.874 0 0 1 .15 1.174 4.419 4.419 0 0 1-.15 1.174H5.008v4.761",
    transform: "translate(82.076 21.05)",
    style: {
      fill: "#e15b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 21",
    d: "M9.478 15.84a6.25 6.25 0 0 1-1.655.171 6.052 6.052 0 0 1-1.655-.171V8.369c0-.79-.387-1.281-1.376-1.281a2.224 2.224 0 0 0-1.483.6v8.152a6.446 6.446 0 0 1-1.655.171A6.053 6.053 0 0 1 0 15.84V.171A6.053 6.053 0 0 1 1.655 0 6.446 6.446 0 0 1 3.31.171v5.337a4.155 4.155 0 0 1 2.88-1 2.953 2.953 0 0 1 3.288 3.177v8.155",
    transform: "translate(90.522 18.944)",
    style: {
      fill: "#e15b6d"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedlineLogo);
export default __webpack_public_path__ + "static/media/medline-logo.808f570b89b33c8d38699bd04d23b4c9.svg";
export { ForwardRef as ReactComponent };